import React from 'react'

/** @deprecated Use icons from icons-v2-generated instead. */
export function RemoteControlIcon({ className = "w-5 h-5", size = 22, color = 'white' }: { className?: string; size?: number; color?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M7.25255 3.25792C10.4255 0.0849247 15.5698 0.0849247 18.7428 3.25792C21.9155 6.43094 21.9157 11.5752 18.7428 14.7482L14.7482 18.7428C11.5752 21.9157 6.43094 21.9155 3.25792 18.7428C0.0849242 15.5698 0.0849254 10.4255 3.25792 7.25255L7.25255 3.25792ZM17.152 4.84874C14.8576 2.55442 11.1377 2.55442 8.84337 4.84874L4.84874 8.84337C2.55442 11.1377 2.55443 14.8576 4.84874 17.152C7.14308 19.446 10.8631 19.4462 13.1573 17.152L17.152 13.1573C19.4462 10.8631 19.446 7.14308 17.152 4.84874Z" />
      <path d="M14.2042 6.20471C14.6434 5.76545 15.3556 5.76561 15.795 6.20471C16.2343 6.64405 16.2343 7.35619 15.795 7.79553L13.7955 9.79504C13.3561 10.2344 12.644 10.2344 12.2046 9.79504C11.7656 9.35568 11.7654 8.64348 12.2046 8.20422L14.2042 6.20471Z" />
    </svg>
  )
}
